import { Link, useLocation } from "wouter";
import { cn } from "@/lib/utils";
import { useGetCurrentUser } from "@workspace/api-client-react";
import { UserMenu } from "@/components/UserMenu";

import { useRunnerView } from "@/hooks/useRunnerView";

const coachNavItems = [
  { href: "/dashboard", label: "Dashboard" },
  { href: "/squads", label: "Squads" },
  { href: "/members", label: "Members" },
];

// WI#23 (D4): the runner app — Today · My History · My Squad.
function runnerNavItems(squadId: number | null | undefined) {
  return [
    { href: "/today", label: "Today" },
    { href: "/history", label: "My History" },
    ...(squadId ? [{ href: `/squads/${squadId}`, label: "My Squad" }] : []),
  ];
}

export default function Layout({ children }: { children: React.ReactNode }) {
  const { isRunnerView, me } = useRunnerView();
  const [location] = useLocation();

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <header className="border-b border-border sticky top-0 z-50 bg-background/95 backdrop-blur">
        <div className="max-w-7xl mx-auto px-6 h-14 flex items-center justify-between">
          <Link href="/" className="flex items-center gap-2">
            <img
              src={`${import.meta.env.BASE_URL}logo.svg`}
              alt="PeakRunning"
              className="h-6 w-auto"
            />
          </Link>
          <div className="flex items-center gap-3">
            <nav className="flex items-center gap-1">
              {(isRunnerView ? runnerNavItems(me?.squadId) : coachNavItems).map((item) => (
                <Link
                  key={item.href}
                  href={item.href}
                  className={cn(
                    "px-3 py-1.5 rounded text-sm font-medium transition-colors",
                    location === item.href || location.startsWith(item.href + "/")
                      ? "bg-primary text-primary-foreground"
                      : "text-muted-foreground hover:text-foreground"
                  )}
                >
                  {item.label}
                </Link>
              ))}
            </nav>
            <UserMenu />
          </div>
        </div>
      </header>
      <main className="flex-1 max-w-7xl mx-auto w-full px-6 py-8">
        {children}
      </main>
    </div>
  );
}
